import React, { useState } from "react";
import styled from "styled-components";
import ListingInterface from "../common/ListingInterface";
import { squadListing } from "../common/listingData";
import Layout from "../common/Layout";
import DynamicTitle from "../common/DynamicTitle";

const SquadListing = ({ pageType }) => {
  const [activeModal, setActiveModal] = useState(false);

  const handleModal = () => setActiveModal(!activeModal);

  return (
    <Layout navType="admin">
      <DynamicTitle title="Squad Lists | Fellowship Product" />
      <StyledDashboardPage activeModal={activeModal}>
            <ListingInterface
              details={squadListing}
              handleModal={handleModal}
              pageType={pageType}
            />
       
      </StyledDashboardPage>
    </Layout>
  );
};

const StyledDashboardPage = styled.div`


`;

export default SquadListing;
